import { render, staticRenderFns } from "./BannerContent.vue?vue&type=template&id=ca35911e&scoped=true&"
import script from "./BannerContent.vue?vue&type=script&lang=js&"
export * from "./BannerContent.vue?vue&type=script&lang=js&"
import style0 from "./BannerContent.vue?vue&type=style&index=0&id=ca35911e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca35911e",
  null
  
)

export default component.exports